import { gql } from '@apollo/client';

// --- Queries ---

// Returns all fleets for the active team plus an injected virtual "Default" entry
// (isDefault=true) representing devices with fleetId=null. Server computes device
// count + online/stale/offline rollups. Use operation name `'Fleets'` in
// refetchQueries after fleet mutations or device moves.
export const FLEETS_QUERY = gql`
  query Fleets($teamId: String, $filter: QueryFleetInput) {
    fleets(teamId: $teamId, filter: $filter) {
      _id
      name
      description
      tags
      isDefault
      deviceCount
      onlineCount
      staleCount
      offlineCount
      createdAt
      updatedAt
    }
  }
`;

export const FLEET_QUERY = gql`
  query Fleet($id: String!, $teamId: String) {
    fleet(_id: $id, teamId: $teamId) {
      _id
      name
      description
      tags
      isDefault
      deviceCount
      onlineCount
      staleCount
      offlineCount
      createdAt
      updatedAt
    }
  }
`;

// --- Mutations ---

export const CREATE_FLEET = gql`
  mutation CreateFleet($input: CreateFleetInput!) {
    createFleet(input: $input) {
      _id
      name
      description
      tags
    }
  }
`;

export const UPDATE_FLEET = gql`
  mutation UpdateFleet($id: String!, $input: UpdateFleetInput!) {
    updateFleet(_id: $id, input: $input) {
      _id
      name
      description
      tags
    }
  }
`;

// reassignTo: null (or omitted) → devices move to virtual Default (fleetId: null)
// reassignTo: '<fleetId>' → devices move to that fleet (same account).
// Must be provided if the fleet has ≥1 device; backend rejects otherwise.
export const DELETE_FLEET = gql`
  mutation DeleteFleet($id: String!, $reassignTo: String) {
    deleteFleet(_id: $id, reassignTo: $reassignTo)
  }
`;

// Bulk move. fleetId === null moves the devices to the virtual Default fleet.
// Returns count of devices modified.
export const MOVE_DEVICES_TO_FLEET = gql`
  mutation MoveDevicesToFleet($deviceIds: [String!]!, $fleetId: String) {
    moveDevicesToFleet(deviceIds: $deviceIds, fleetId: $fleetId)
  }
`;
